import { render, staticRenderFns } from "./DeepLink.vue?vue&type=template&id=61d40d1c&"
import script from "./DeepLink.vue?vue&type=script&lang=js&"
export * from "./DeepLink.vue?vue&type=script&lang=js&"
import style0 from "./DeepLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports